const DEFAULT_STREAM_HOST = "customer-repfrq2uozf9ok0e.cloudflarestream.com";

/**
 * Reset URLs can arrive as Thrive's player page. The Stream SDK only controls
 * native Cloudflare iframe embeds, so rebuild the URL from the video id.
 */
export function streamEmbedUrl(videoUrl: string): string {
  const source = new URL(videoUrl, window.location.href);
  const videoId = source.pathname.split("/").filter(Boolean)[0];

  if (!videoId) return videoUrl;

  const sourceHost = source.hostname;
  const embedHost = sourceHost.includes("cloudflarestream.com")
    ? sourceHost
    : sourceHost.includes("videodelivery.net")
      ? "iframe.videodelivery.net"
      : DEFAULT_STREAM_HOST;
  const embedPath = embedHost === "iframe.videodelivery.net" ? `/${videoId}` : `/${videoId}/iframe`;
  const embed = new URL(`https://${embedHost}${embedPath}`);
  const token = source.searchParams.get("token");

  if (token) embed.searchParams.set("token", token);
  embed.searchParams.set("autoplay", "true");
  embed.searchParams.set("controls", "false");
  return embed.toString();
}
